import cx from 'classnames'
import Styles from '../TitleSelector.module.scss'
import { TextFieldLoadingState } from 'components/Wizards/TextFieldLoadingState/TextFieldLoadingState'

const TitleOptionStub = () => (
  <div className={cx(Styles.titleOption, Styles.loading)}>
    <TextFieldLoadingState lines={3} variant="tertiary" />
  </div>
)

export const TitleSelectorLoadingState = () => (
  <>
    <TitleOptionStub />
    <TitleOptionStub />
    <TitleOptionStub />
    <TitleOptionStub />
    <TitleOptionStub />
  </>
)
